import { Outlet } from 'react-router-dom'

const BillingContainer = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default BillingContainer
